import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
  signal,
} from '@angular/core';
import { Router } from '@angular/router';
import { SubscriptionManager, subscribeOnce } from '@tmx/core';
import { switchMap } from 'rxjs/operators';
import { fromFetch } from 'rxjs/fetch';
import { NgStyle } from '@angular/common';
import { acceptTerms, getCurrentAuthenticatedUser } from '@tmx/auth';
import { AlertComponent, ButtonComponent } from '@tmx/modus-operandi';

@Component({
  templateUrl: './accept-terms.component.html',
  styleUrls: ['./accept-terms.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, AlertComponent, ButtonComponent],
})
export class AcceptTermsComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);

  private readonly sm = new SubscriptionManager();
  loading = signal(false);
  errorMessage = signal<string | null>(null);
  tosContent = signal<string | null>(null);
  showAcceptButton = signal(
    !getCurrentAuthenticatedUser().currentTermsAccepted
  );

  currentYear = new Date().getFullYear();

  ngOnInit() {
    this.sm.manage = fromFetch(
      new Request('/assets/terms-of-use-v1.html', {
        method: 'GET',
        headers: {
          'content-type': 'text/html',
        },
      })
    )
      .pipe(switchMap((response: Response) => response.text()))
      .subscribe({
        next: (response) => {
          this.tosContent.set(response);
        },
        error: () => {
          this.tosContent.set(null);
        },
      });
  }

  acceptTermsOfService() {
    this.loading.set(true);

    subscribeOnce(acceptTerms(1), {
      next: () => {
        this.router.navigate(['/ams'], {
          state: { startTour: true },
        });
      },
      error: () => {
        this.loading.set(false);
        this.errorMessage.set('Something went wrong. Please try again later.');
      },
    });
  }

  ngOnDestroy() {
    this.sm.unsubscribe();
  }
}
